const short = require('short-uuid');

export const validateTemplateConnection = (templateNode, transactions) => {
    let status = false;
    transactions.forEach(transaction => {
        transaction.templateTransactions.forEach(template => {
            if (template.templateId === templateNode.id) {
                status = true;
            }
        })
    })
    return status;
}

export const validateNodeConnections = (connection, events) => {
    const { source, target } = connection;
    const matchingEvents = events.filter(ev => (ev.src == source || ev.src === target) && (ev.dst == source || ev.dst == target));
    if (matchingEvents.length > 0) {
        return true
    }
    return false;
}

/** Create connection string between two nodes */
export const createConnection = (source,target,sourceSide,targetSide) => {
    return {
        id: short.generate(),
        source: source.id,
        sourceHandle: sourceSide,
        target: target.id,
        targetHandle: targetSide,
    }
}